// extracted by mini-css-extract-plugin
export default {"section":"AboutSection_section__ERmmm","section-header":"AboutSection_section-header__PcZfQ"};